import React from 'react';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';
import { Edit, Trash2, ExternalLink } from 'lucide-react';

/**
 * ReleaseCard - Display card for a single release
 * Shows release artwork, info, and action buttons
 */
export const ReleaseCard = ({ release, onEdit, onDelete }) => {
  return (
    <Card className="bg-black/50 border-orange-500/30 hover:border-orange-500 hover:shadow-xl hover:shadow-orange-500/30 hover:-translate-y-1 overflow-hidden group p-0 transition-all duration-300">
      <div className="relative aspect-square overflow-hidden">
        <img 
          src={release.artwork} 
          alt={release.title} 
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" 
        />
        <div className="absolute top-3 right-3 z-10">
          <span className="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
            {release.type}
          </span>
        </div>
      </div>
      <div className="p-4 pb-6">
        <h3 className="text-lg font-bold text-white">{release.title}</h3>
        <p className="text-gray-400 text-sm">
          {release.artists ? release.artists.join(', ') : release.artist || 'Unknown Artist'}
        </p>
        <p className="text-gray-500 text-xs mt-1">{release.releaseDate}</p>
        <div className="flex gap-2 mt-4">
          <Button 
            size="sm" 
            variant="outline" 
            onClick={() => onEdit(release)} 
            className="flex-1 border-green-500/30 hover:bg-green-500/20"
          >
            <Edit className="w-4 h-4 mr-1" /> Edit
          </Button>
          <Button 
            size="sm" 
            variant="outline" 
            onClick={() => onDelete(release)} 
            className="flex-1 border-red-500/30 hover:bg-red-500/20 text-red-400"
          >
            <Trash2 className="w-4 h-4 mr-1" /> Delete
          </Button>
          <Button 
            size="sm" 
            variant="outline" 
            onClick={() => window.open(release.soundcloudUrl, '_blank')} 
            className="border-orange-500/30 hover:bg-orange-500/20"
          >
            <ExternalLink className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </Card>
  );
};
